var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import styled from '@emotion/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Avatar, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCustomerByIdAPI } from '../../../api/url';
import { CustomerEditIcon } from '../../../assets/customIcons';
import { GreenVerifiedTick, MailGrayIcon, MapGrayIcon } from '../../../assets/images';
import { MuiStack } from '../../../components';
import SkeletonLoader from '../../../components/atoms/sketeton';
import EditCustomerInfo from '../../../components/templates/editCustomerInfo';
import { DEFAULT_MOB_NO_REGEX, EParentModuleName, LOCAL_STORAGE_KEYS, defaultMobile } from '../../../constants';
import { getByIdAPI, setState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import VehicleSelectCard from './vehicleCardSelect';
var AccordionSummaryList = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordionSummary, _extends({
    expandIcon: /*#__PURE__*/ React.createElement(ExpandMoreIcon, null)
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        "& .MuiAccordionSummary-expandIconWrapper": {
            alignSelf: "flex-start",
            margin: "10px"
        }
    };
});
export default function CustomerAndInstallBaseSelect(props) {
    var _this = this;
    var _customerData$PersonC, _customerData$PersonC2, _customerData$Person, _customerData$Person2, _customerData$Person$, _customerData$Person3, _customerData$Person$2, _customerData$Person4, _customerData$Address, _customerData$Address2, _customerData$Address3, _customerData$Address4, _customerData$Address5;
    var VehiclesDetailsList = props.VehiclesDetailsList, customerDetails = props.customerDetails, isCheckBoxVisible = props.isCheckBoxVisible, onSelectVehicle = props.onSelectVehicle, parentDocument = props.parentDocument, isServiceHistoryLabel = props.isServiceHistoryLabel, isDisabled = props.isDisabled, createAndEditFlow = props.createAndEditFlow, parentComponent = props.parentComponent, IsFromParentAPt = props.IsFromParentAPt;
    var _a = props.createAndEditFlow || {}, isAppointment = _a.isAppointment, isInspection = _a.isInspection, isEstimate = _a.isEstimate, isJobCard = _a.isJobCard;
    var shouldAccordionBeClosed = isAppointment === "Update" || isInspection === "Update" || isEstimate === "Update" || isJobCard === "Update" || isServiceHistoryLabel;
    var initialExpandedState = shouldAccordionBeClosed ? false : "panel1";
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _b = React.useState(initialExpandedState), expanded = _b[0], setExpanded = _b[1];
    // const [expanded, setExpanded] = React.useState<string | false>(createAndEditFlow?.isAppointment == "Update" || createAndEditFlow?.isInspection == "Update" || createAndEditFlow?.isEstimate == "Update" || createAndEditFlow?.isJobCard == "Update" || isServiceHistoryLabel ? false : "panel1");
    var _c = useState(!isCheckBoxVisible ? (VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.length) > 0 ? VehiclesDetailsList[0] : null : null), selectedVehicle = _c[0], setSelectedVehicle = _c[1];
    var _d = useState(false), isInvalidMobile = _d[0], setIsInvalidMobile = _d[1];
    var _e = useState(isInvalidMobile), editCustomer = _e[0], setEditCustomer = _e[1];
    var _f = useAppSelector(function (state) { return state.crud; }), getCustomerInfo = _f.getCustomerInfo, JCCreateStartTime = _f.JCCreateStartTime;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var _g = useState(true), isShowSkeleton = _g[0], setShowSkeleton = _g[1];
    var customerData = getCustomerInfo === null || getCustomerInfo === void 0 ? void 0 : getCustomerInfo.data;
    var MobileNoRegex = getLocalStorageItem(LOCAL_STORAGE_KEYS.MOBILE_NO_REGEX);
    var isEmailVerified = getLocalStorageItem(LOCAL_STORAGE_KEYS.IS_EMAIL_VERIFIED);
    var primaryContact = customerData === null || customerData === void 0 || (_customerData$PersonC = customerData.PersonContactPoint) === null || _customerData$PersonC === void 0 ? void 0 : _customerData$PersonC.find(function (item) { return item.ContactType === "Primary"; });
    var secondaryContact = customerData === null || customerData === void 0 || (_customerData$PersonC2 = customerData.PersonContactPoint) === null || _customerData$PersonC2 === void 0 ? void 0 : _customerData$PersonC2.find(function (item) { return item.ContactType === "Secondary"; });
    var getCustomerInfoAPI = function () { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, _result$payload2, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'getCustomerInfo',
                        url: getCustomerByIdAPI(customerDetails ? customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId : "")
                    }))];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.value) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && (_result$payload2 = _result$payload2.value) !== null && _result$payload2 !== void 0 && _result$payload2.success)
                        setShowSkeleton(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (customerDetails !== null && customerDetails !== void 0 && customerDetails.CustomerId) {
            getCustomerInfoAPI();
        }
    }, [customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.CustomerId]);
    // useEffect(() => {
    //     if (VehiclesDetailsList?.length > 0) {
    //         setSelectedVehicle(VehiclesDetailsList[0])
    //     }
    // }, [VehiclesDetailsList])
    useEffect(function () {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 350) {
                setExpanded(false);
            }
        });
    }, []);
    useEffect(function () {
        var regMob = MobileNoRegex ? MobileNoRegex : DEFAULT_MOB_NO_REGEX;
        regMob = new RegExp(regMob);
        if ((primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber) === defaultMobile) {
            setIsInvalidMobile(true);
            setEditCustomer(true);
        }
        else if (isEmailVerified === "true") {
            if ((primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.Email) === null || (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.Email) === "") {
                setIsInvalidMobile(true);
                setEditCustomer(true);
            }
        }
        else if (primaryContact !== null && primaryContact !== void 0 && primaryContact.MobileNumber && !(primaryContact !== null && primaryContact !== void 0 && primaryContact.IsMobileVerified) && !regMob.test(primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber)) {
            setIsInvalidMobile(true);
            setEditCustomer(true);
        }
        if (primaryContact !== null && primaryContact !== void 0 && primaryContact.MobileNumber && !(primaryContact !== null && primaryContact !== void 0 && primaryContact.IsMobileVerified) && parentComponent !== EParentModuleName.Jobcard && !IsFromParentAPt === true) {
            setEditCustomer(true);
        }
        if (customerData)
            setShowSkeleton(false);
    }, [primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber]);
    var handleSelectVehicle = function (item) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            console.log("item --- ", item);
            if (item !== null && item !== void 0 && item.id && (item === null || item === void 0 ? void 0 : item.id) !== (selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.id)) {
                setSelectedVehicle(item);
                if (onSelectVehicle) {
                    onSelectVehicle(item);
                }
            }
            else {
                if (onSelectVehicle) {
                    onSelectVehicle(null);
                }
                setSelectedVehicle(null);
                dispatch(setState({
                    key: "preDocumentFetch",
                    value: []
                }));
            }
            return [2 /*return*/];
        });
    }); };
    var handleClickEvent = function (event) {
        event.stopPropagation();
        setEditCustomer(function (prev) { return !prev; });
    };
    var navigateToPaging = function () {
        if (parentComponent === EParentModuleName.Appointment) {
            navigate("/appointment");
        }
        else if (parentComponent === EParentModuleName.Inspection) {
            navigate("/Inspection");
        }
        else if (parentComponent === EParentModuleName.ServiceEstimate) {
            navigate("/serviceEstimate");
        }
        else if (parentComponent === EParentModuleName.Jobcard) {
            navigate("/jobCard");
        }
        else {
            navigate(-1);
        }
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        width: "100%"
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: isDesktop ? 2 : 0
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        pb: "10px"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "Customer-vehicle-details",
        sx: {
            fontWeight: 'strong',
            fontSize: 'base'
        }
    }, t("Customer Details"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "customer-details-card",
        direction: 'column',
        border: "1px solid ".concat(systemColor.grey),
        p: 2,
        borderRadius: 3
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        justifyContent: 'space-between',
        flexDirection: 'row'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2.5,
        sm: 1.2,
        md: 2,
        lg: 1.5
    }, /*#__PURE__*/ React.createElement(Avatar, {
        id: "profile-icon",
        sx: {
            width: "48px",
            height: '48px'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 9.5,
        sm: 10.8,
        md: 10,
        lg: 10.5
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, !isShowSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11,
        sm: 11,
        md: 11,
        sx: {
            placeSelf: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'medium',
        fontSize: "base",
        id: "customerNameId"
    }, customerData !== null && customerData !== void 0 && (_customerData$Person = customerData.Person) !== null && _customerData$Person !== void 0 && _customerData$Person.GivenName || customerData !== null && customerData !== void 0 && (_customerData$Person2 = customerData.Person) !== null && _customerData$Person2 !== void 0 && _customerData$Person2.FamilyName ? "".concat((_customerData$Person$ = customerData === null || customerData === void 0 || (_customerData$Person3 = customerData.Person) === null || _customerData$Person3 === void 0 ? void 0 : _customerData$Person3.GivenName) !== null && _customerData$Person$ !== void 0 ? _customerData$Person$ : ' ', " ").concat((_customerData$Person$2 = customerData === null || customerData === void 0 || (_customerData$Person4 = customerData.Person) === null || _customerData$Person4 === void 0 ? void 0 : _customerData$Person4.FamilyName) !== null && _customerData$Person$2 !== void 0 ? _customerData$Person$2 : ' ').trim() : "-")), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '38vw',
            height: '3vh',
            padding: "1.5px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1,
        sm: 1,
        md: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(CustomerEditIcon, {
        id: "viewBtn",
        sx: {
            height: '20px',
            width: '20px',
            cursor: 'pointer'
        },
        onClick: function (event) { return handleClickEvent(event); }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            gap: '5px',
            marginBottom: '3px',
            paddingTop: 5,
            marginTop: 0
        }
    }, isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '25vw',
            height: '3vh',
            padding: "1.5px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "normal",
        color: 'secondary.500',
        id: "mobileNo"
    }, (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber) === defaultMobile ? "-" : primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.MobileNumber), (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.IsMobileVerified) && /*#__PURE__*/ React.createElement("img", {
        src: GreenVerifiedTick,
        alt: "succesicon"
    }), /*#__PURE__*/ React.createElement(Divider, {
        orientation: "vertical",
        flexItem: true,
        sx: {
            color: 'secondary.500'
        }
    }), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '25vw',
            height: '3vh',
            padding: '1.5px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "normal",
        color: 'secondary.500',
        id: "additionalMobileNO"
    }, (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber) === defaultMobile ? "-" : secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber), (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.IsAlternateNumberVerified) && (secondaryContact === null || secondaryContact === void 0 ? void 0 : secondaryContact.MobileNumber) !== defaultMobile && /*#__PURE__*/ React.createElement("img", {
        src: GreenVerifiedTick,
        alt: "succesicon"
    })))), /*#__PURE__*/ React.createElement("div", {
        style: {
            margin: '16px -16px 0px -16px',
            border: '0.5px solid #DEE4EB'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        px: 1,
        pt: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            gap: '12px',
            marginBottom: '3px'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: MailGrayIcon,
        alt: "mailicon"
    }), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '60vw',
            height: '3vh',
            padding: '1.5px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "normal",
        id: "emailId",
        color: 'secondary.500',
        style: {
            textWrap: "pretty",
            wordBreak: "break-word"
        }
    }, primaryContact !== null && primaryContact !== void 0 && primaryContact.Email ? primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.Email : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
        gap: "10px",
        alignItems: 'flex-start',
        marginTop: "12px"
    }, /*#__PURE__*/ React.createElement("img", {
        src: MapGrayIcon,
        alt: "mapIcon"
    }), isShowSkeleton && /*#__PURE__*/ React.createElement("span", {
        "flex-direction": 'column',
        style: {
            width: '60vw',
            height: '3vh',
            padding: '1.5px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Typography, {
        id: "addressId",
        fontSize: "sm",
        fontWeight: "normal",
        color: 'secondary.500',
        style: {
            wordBreak: "break-all",
            textWrap: "pretty"
        }
    }, customerData !== null && customerData !== void 0 && customerData.Address && (_customerData$Address = customerData.Address[0]) !== null && _customerData$Address !== void 0 && _customerData$Address.Address1 ? [(_customerData$Address2 = customerData.Address[0]) === null || _customerData$Address2 === void 0 ? void 0 : _customerData$Address2.Address1, (_customerData$Address3 = customerData.Address[0]) === null || _customerData$Address3 === void 0 ? void 0 : _customerData$Address3.Address2, (_customerData$Address4 = customerData.Address[0]) === null || _customerData$Address4 === void 0 ? void 0 : _customerData$Address4.Address3, (_customerData$Address5 = customerData.Address[0]) === null || _customerData$Address5 === void 0 ? void 0 : _customerData$Address5.Address4].filter(function (address) { return address && address.trim() !== ''; }) // Filters out empty or whitespace-only values
        .join(', ') // Joins the non-empty values with commas
        : '-'))))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        p: '10px 0px'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "Customer-vehicle-details",
        sx: {
            fontWeight: 'strong',
            fontSize: 'base'
        }
    }, isCheckBoxVisible ? t("Select vehicle") : t("Vehicle Details"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, VehiclesDetailsList === null || VehiclesDetailsList === void 0 ? void 0 : VehiclesDetailsList.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(VehicleSelectCard, {
            key: item + index,
            customerDetails: customerDetails,
            selectedVehicle: selectedVehicle,
            vehicleDetails: item,
            onSelectVehicle: function () { return handleSelectVehicle(item); },
            onDeSelectVehicle: function () {
                handleSelectVehicle("");
            },
            isCheckBoxVisible: isCheckBoxVisible,
            isServiceHistoryLabel: isServiceHistoryLabel,
            isDisabled: isDisabled,
            IsFromParentAPt: IsFromParentAPt
        });
    }))))), editCustomer && customerDetails && /*#__PURE__*/ React.createElement(EditCustomerInfo, {
        parentDocumentName: parentDocument,
        open: editCustomer,
        onUpdateClose: function () {
            setEditCustomer(function (prev) { return !prev; });
        },
        onClose: function () {
            if (isInvalidMobile) {
                navigateToPaging();
            }
            else {
                setEditCustomer(function (eve) { return !eve; });
            }
        },
        data: customerDetails,
        isDisabled: isDisabled ? isDisabled : false,
        isInvalidMobile: isInvalidMobile,
        setEditCustomerFlag: function (value) {
            setIsInvalidMobile(value);
        },
        vehicleDetails: VehiclesDetailsList
    }));
}
